// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1YQFt","row":"Node_row__UBnYz","label":"Node_label__3k_37","footer":"Node_footer__PcqyB"};